/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Verdict_Blocked_TitleInputs */

const cs_import_verdict_blocked_title = /** @type {(inputs: Import_Verdict_Blocked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blokováno chybami`)
};

const en_import_verdict_blocked_title = /** @type {(inputs: Import_Verdict_Blocked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocked by errors`)
};

/**
* | output |
* | --- |
* | "Blocked by errors" |
*
* @param {Import_Verdict_Blocked_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_verdict_blocked_title = /** @type {((inputs?: Import_Verdict_Blocked_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Verdict_Blocked_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_verdict_blocked_title(inputs)
	return cs_import_verdict_blocked_title(inputs)
});